import { noddiAsync, URLKeys } from 'noddi-async';
import { useCurrentBrand } from '../stores/BrandStore/brandStore';

const CAPACITY_LOOKAHEAD_DAYS = 90;

export function useMobileBookingAvailability() {
  const { currentBrand } = useCurrentBrand();
  const {
    data: availability,
    isLoading,
    isPending,
    error
  } = noddiAsync.useGet({
    type: URLKeys.getMobileBookingAvailability,
    input: {
      brandDomain: currentBrand,
      lookaheadDays: CAPACITY_LOOKAHEAD_DAYS
    },
    queryConfig: {
      enabled: !!currentBrand
    }
  });

  return {
    hasFutureCapacity: availability?.hasFutureCapacity ?? false,
    isLoading: !!currentBrand && (isLoading || isPending),
    error: error ?? null
  };
}
